import { Toaster as ArkToaster, Toast } from '@ark-ui/react/toast'
import { Icon } from '#lib/ui/icon/icon'
import { Spinner } from '#lib/ui/loaders/spinner'
import { toast } from './toast'
import { ToastStyles as styles } from './toast.css'

export function Toaster() {
  return (
    <ArkToaster toaster={toast}>
      {toast => (
        <Toast.Root className={styles.container}>
          <div className={styles.outerTitleContainer}>
            <span className={styles.innerTitleContainer}>
              {/* success icon has a background already, so doesn't need a colored circle behind it */}
              {toast.type === 'loading' && <Spinner size={16} />}
              {toast.type === 'success' && (
                <Icon icon="success" size="sm" className={styles.successIcon} />
              )}

              {toast.type === 'error' && (
                <span
                  className={styles.icon({
                    type:
                      toast.type === 'success'
                        ? 'success'
                        : toast.type === 'error'
                          ? 'error'
                          : undefined,
                  })}
                >
                  <Icon icon="close" size="xs" />
                </span>
              )}

              <Toast.Title>{toast.title}</Toast.Title>
            </span>

            <Toast.CloseTrigger className={styles.closeButton}>
              <Icon icon="close" size="sm" />
            </Toast.CloseTrigger>
          </div>

          {toast.description && (
            <Toast.Description>{toast.description}</Toast.Description>
          )}
        </Toast.Root>
      )}
    </ArkToaster>
  )
}
